export default __webpack_public_path__ + "static/media/rounded-train.5ee57d17.webp";